"use client"

import styled from "@emotion/styled"
import BlockWrapper from "../../common/BlockWrapper"
import CommonTitle from "../../common/bit/CommonTitle"

export const StyledBlockWrapper = styled(BlockWrapper)``

export const StyledCommonTitle = styled(CommonTitle)``
